(function () {
  const LOG = (...args) => console.log('%c[storefront-search]', 'color:#00AEEF;font-weight:bold', ...args);
  const ERR = (...args) => console.error('%c[storefront-search]', 'color:#E53935;font-weight:bold', ...args);

  const cfg = window.__storefrontSearch;
  if (!cfg || !cfg.token || !cfg.shop) {
    ERR('config missing', cfg);
    return;
  }
  if (!cfg.term) {
    LOG('no search term, exiting');
    return;
  }

  const gql = `query($q: String!) {
    products(first: 24, query: $q) {
      edges {
        node {
          handle
          title
          variants(first: 50) { edges { node { sku title } } }
        }
      }
    }
  }`;

  const normTerm = cfg.term.toLowerCase().replace(/\s+/g, '');
  const matchingSkus = (product) => (product.variants.edges || [])
    .map((e) => e.node.sku)
    .filter((s) => s && s.toLowerCase().replace(/\s+/g, '').includes(normTerm))
    .join(', ');

  function getOrCreateGridUl() {
    let ul = document.querySelector('#product-grid ul.collection-results--products');
    if (ul) return { ul, created: false };

    const header = document.querySelector('.template-search__header');
    if (!header || !header.parentNode) {
      ERR('no .template-search__header found; cannot create grid wrapper');
      return null;
    }

    const noResult = document.querySelector('.search__form-no-result');
    if (noResult) noResult.style.display = 'none';
    const emptyWrapper = document.querySelector('.template-search--empty');
    if (emptyWrapper) emptyWrapper.classList.remove('template-search--empty');

    const wrapper = document.createElement('div');
    wrapper.className = 'collection-wrapper collection-wrapper_no-facets';
    wrapper.setAttribute('data-sf-created', 'true');
    // The .search-results__top block is required — removing it breaks the grid's width/flex layout.
    // We use "Products" (matches native) instead of a custom "Code match results" label.
    wrapper.innerHTML =
      '<div id="product-grid" class="template-search__results collection collection-product products-grid products-grid_no-filter" data-id="sf-injected">' +
        '<div class="search-results__top first">' +
          '<h3 class="h6">Products</h3>' +
        '</div>' +
        '<ul class="collection-results collection-results--products" role="list"></ul>' +
      '</div>';
    header.parentNode.insertBefore(wrapper, header.nextSibling);
    return { ul: wrapper.querySelector('ul'), created: true };
  }

  const started = performance.now();
  fetch(`https://${cfg.shop}/api/2024-10/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': cfg.token
    },
    body: JSON.stringify({ query: gql, variables: { q: cfg.term } })
  })
    .then((r) => r.json())
    .then((data) => {
      const elapsed = Math.round(performance.now() - started);
      if (data.errors) {
        ERR('GraphQL errors:', data.errors);
        return null;
      }
      const products = (data.data && data.data.products && data.data.products.edges || []).map((e) => e.node);
      LOG(`term="${cfg.term}" | storefront returned ${products.length} products in ${elapsed}ms | cost=${data.extensions && data.extensions.cost && data.extensions.cost.requestedQueryCost}`);

      const nativeHandles = Array.from(document.querySelectorAll('#product-grid a[href*="/products/"]'))
        .map((a) => {
          const m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
          return m ? m[1] : null;
        })
        .filter(Boolean);
      const nativeSet = new Set(nativeHandles);

      const matched = products.filter((p) => nativeSet.has(p.handle));
      const extras = products.filter((p) => !nativeSet.has(p.handle));

      LOG(`native rendered: ${nativeSet.size} unique handles | matched: ${matched.length} | extras: ${extras.length}`);
      if (extras.length) {
        console.table(extras.map((p) => ({ handle: p.handle, title: p.title, matchingSkus: matchingSkus(p) })));
      }
      return extras;
    })
    .then((extras) => {
      if (!extras || extras.length === 0) {
        LOG('no extras to render, done');
        return;
      }
      const handlesParam = extras.map((p) => p.handle).join(',');
      const url = `/search?q=${encodeURIComponent(handlesParam)}&sections=storefront-card-renderer`;
      LOG('fetching rendered cards:', url);

      const fetchStart = performance.now();
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then((json) => {
          const elapsed = Math.round(performance.now() - fetchStart);
          const html = json['storefront-card-renderer'];
          if (!html) {
            ERR('section renderer returned no HTML; full response:', json);
            return;
          }

          const temp = document.createElement('div');
          temp.innerHTML = html;
          const items = temp.querySelectorAll('li[data-sf-rendered]');
          LOG(`section render took ${elapsed}ms | parsed ${items.length} <li> cards`);

          if (items.length === 0) {
            LOG('no cards parsed from section HTML, nothing to inject');
            return;
          }

          const target = getOrCreateGridUl();
          if (!target) return;
          LOG(`injection target: ${target.created ? 'newly created wrapper' : 'existing #product-grid ul'} | existing children: ${target.ul.children.length}`);

          items.forEach((li) => {
            li.setAttribute('data-sf-injected', 'true');
            target.ul.appendChild(li);
          });
          LOG(`injected ${items.length} cards | ul now has ${target.ul.children.length} children`);

          // Phase 5: Replicate global.js's card-hover-sku observer for injected cards.
          // global.js:43 captures .card-wrapper elements once at load; our dynamically
          // injected cards miss it, so hover SKU text never updates on swatch change.
          const applyHoverSkuFromCurrentVariant = (wrapper) => {
            const vid = wrapper.getAttribute('swatch-current-variant');
            if (!vid) return;
            const jsonEl = wrapper.querySelector('#variant-json');
            const skuEl = wrapper.querySelector('.card-hover-sku');
            if (!jsonEl || !skuEl) return;
            try {
              const data = JSON.parse(jsonEl.textContent);
              const match = (data.variants || []).find((v) => String(v.id) === String(vid));
              if (match && match.sku) skuEl.textContent = match.sku;
            } catch (e) { ERR('variant-json parse failed:', e); }
          };

          const observeWrapper = (wrapper) => {
            const obs = new MutationObserver(() => applyHoverSkuFromCurrentVariant(wrapper));
            obs.observe(wrapper, { attributes: true, attributeFilter: ['swatch-current-variant'], subtree: false });
            applyHoverSkuFromCurrentVariant(wrapper); // Catch state VSK may already have set.
          };

          let wrapperCount = 0;
          items.forEach((li) => {
            li.querySelectorAll('.card-wrapper').forEach((w) => {
              observeWrapper(w);
              wrapperCount++;
            });
          });
          LOG(`attached hover-sku observer to ${wrapperCount} .card-wrapper(s)`);

          // Phase 5: Fix the tab title. Server rendered "0 results found" based on
          // search.results_count; now that we've injected cards, correct it to the true count.
          const totalVisible = document.querySelectorAll('#product-grid ul.collection-results--products > li').length;
          const noun = totalVisible === 1 ? 'result' : 'results';
          const before = document.title;
          document.title = document.title.replace(/\b\d+\s+results?\s+found\b/i, `${totalVisible} ${noun} found`);
          if (document.title !== before) LOG(`updated tab title: "${before}" -> "${document.title}"`);

          if (typeof initializeSwatchesOnAllCards === 'function') {
            LOG('triggering initializeSwatchesOnAllCards() so VSK + swatch click runs on injected cards');
            try {
              initializeSwatchesOnAllCards();
            } catch (e) {
              ERR('initializeSwatchesOnAllCards threw:', e);
            }
          } else {
            ERR('initializeSwatchesOnAllCards is not defined - search_refinements.js may not have loaded');
          }
        });
    })
    .catch((e) => ERR('pipeline failed:', e));
})();

// ============================================================================
// Phase 6: predictive dropdown augmentation.
// Called from predictive-search.js after each native render (cache hit + fetch).
// Only activates when window.__storefrontSearch is present (search-page testing scope).
// ============================================================================
(function () {
  const PLOG = (...args) => console.log('%c[sf-predictive]', 'color:#8E44AD;font-weight:bold', ...args);
  const PERR = (...args) => console.error('%c[sf-predictive]', 'color:#E53935;font-weight:bold', ...args);

  const predictiveCache = {}; // keyed by lowercased term -> {extras, renderedHtml}
  let inFlightController = null;
  let inFlightTerm = null;

  // Scoped swatch processor: only touches the cards passed in. Mirrors search_refinements.js's
  // swatchCallback priority ladder but takes an explicit term so we don't need to override globals.
  async function processCardsWithTerm(cards, term) {
    const searchTermLower = term.toLowerCase();
    const normTerm = searchTermLower.replace(/\s+/g, '');

    const waitForVsk = (card, timeout) => new Promise((resolve) => {
      const interval = 50;
      let elapsed = 0;
      const check = () => {
        const el = card.querySelector('variant-swatch-king');
        if (el) return resolve(el);
        elapsed += interval;
        if (elapsed >= timeout) return resolve(null);
        setTimeout(check, interval);
      };
      check();
    });

    for (const card of cards) {
      const vsk = await waitForVsk(card, 5000);
      if (!vsk) continue;
      const parent = vsk.parentElement && vsk.parentElement.parentElement;
      const jsonEl = (parent || card).querySelector('#variant-json');
      if (!jsonEl) continue;
      let variants = [];
      try { variants = (JSON.parse(jsonEl.textContent).variants) || []; } catch (e) { continue; }

      let match = variants.find((v) => v.sku && (v.sku.toLowerCase().replace(/\s+/g, '') === normTerm || v.sku.toLowerCase().replace(/\s+/g, '').startsWith(normTerm)));
      if (!match) {
        match = variants.find((v) => {
          if (typeof v.sku !== 'string') return false;
          const parts = v.sku.split(' ');
          if (parts.length < 2) return false;
          const code = parts[1].toLowerCase();
          return code === searchTermLower || code.startsWith(searchTermLower);
        });
      }
      if (match && match.title && parent) {
        const sel = `div.swatch-selector[data-value="${CSS.escape(match.title)}"]`;
        const target = parent.querySelector(sel);
        if (target) target.click();
      }
    }
  }

  window.__storefrontAugmentPredictive = function (term, predictiveInstance) {
    const cfg = window.__storefrontSearch;
    if (!cfg || !cfg.token || !cfg.shop) return; // kill switch: no scaffold loaded
    if (!term || !term.trim()) return;

    const t = term.trim();
    const key = t.toLowerCase();

    if (inFlightController && inFlightTerm !== key) {
      inFlightController.abort();
    }
    inFlightController = new AbortController();
    inFlightTerm = key;
    const signal = inFlightController.signal;

    const resultsContainer = predictiveInstance && predictiveInstance.predictiveSearchResults;
    if (!resultsContainer) {
      PERR(`"${t}" | no predictiveSearchResults container; cannot proceed`);
      return;
    }

    const findDropdown = () => resultsContainer.querySelector('#predictive-search-results-products-list');

    const ensureDropdownExists = () => {
      let ul = findDropdown();
      if (ul) return ul;

      // Native produced no product list. Hide the "no results" paragraph and create our own structure.
      const noResults = resultsContainer.querySelector('.predictive-search__text');
      if (noResults) noResults.style.display = 'none';

      let resultsBox = resultsContainer.querySelector('#predictive-search-results');
      if (!resultsBox) {
        resultsBox = document.createElement('div');
        resultsBox.id = 'predictive-search-results';
        resultsBox.setAttribute('role', 'listbox');
        resultsBox.setAttribute('tabindex', '-1');
        resultsContainer.appendChild(resultsBox);
      }

      const wrapper = document.createElement('div');
      wrapper.id = 'predictive-search-results-groups-wrapper';
      wrapper.className = 'predictive-search__results-groups-wrapper';
      wrapper.setAttribute('data-sf-created', 'true');
      // IMPORTANT: .active class on the <ul> is required — CSS hides .predictive-search__results-list
      // by default and only shows .predictive-search__results-list.active (display: grid).
      // The .predictive-search__result-tabs block is also required for layout — removing it
      // collapses the grid, so we keep it with native "Products" text instead of a custom label.
      wrapper.innerHTML =
        '<div class="predictive-search__result-group card-link-small">' +
          '<div class="predictive-search__result-tabs">' +
            '<div class="predictive-search__result-tab h6 active" data-type-target="products">Products</div>' +
          '</div>' +
          '<ul id="predictive-search-results-products-list" class="predictive-search__results-list predictive-search__results-list_products list-unstyled active" role="group" tabindex="-1" data-type="products"></ul>' +
        '</div>';
      resultsBox.appendChild(wrapper);

      if (predictiveInstance.open) predictiveInstance.open();
      predictiveInstance.setAttribute('results', 'true');

      return wrapper.querySelector('#predictive-search-results-products-list');
    };

    const normTerm = key.replace(/\s+/g, '');
    const skuMatches = (sku) => sku && sku.toLowerCase().replace(/\s+/g, '').includes(normTerm);

    const existingHandles = () => {
      const ul = findDropdown();
      if (!ul) return new Set();
      return new Set(Array.from(ul.querySelectorAll('a[href*="/products/"]'))
        .map((a) => (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/))
        .filter(Boolean).map((m) => m[1]));
    };

    const runPipeline = (extras, renderedHtml) => {
      // Even with zero extras, we still want to run swatch processing on whatever native rendered,
      // so SKU searches that native handles natively (e.g. "4269X") still get the right swatch clicked.
      const ul = findDropdown();
      const nativeCards = ul ? Array.from(ul.querySelectorAll(':scope > li .card-wrapper')) : [];

      if (!extras || extras.length === 0) {
        PLOG(`"${t}" | no extras; running swatch processing on ${nativeCards.length} native dropdown card(s)`);
        if (nativeCards.length > 0) processCardsWithTerm(nativeCards, t);
        return;
      }

      const dropdown = ensureDropdownExists();
      if (!dropdown) {
        PERR(`"${t}" | could not create dropdown ul`);
        return;
      }

      const temp = document.createElement('div');
      temp.innerHTML = renderedHtml;
      const items = temp.querySelectorAll('li[data-sf-rendered]');
      PLOG(`"${t}" | injecting ${items.length} extras into dropdown`);

      const injectedWrappers = [];
      items.forEach((li) => {
        // Our storefront-card-renderer section outputs search-page classes (template-search__item
        // forces width:25%). Swap to predictive-specific classes so the card renders at full
        // grid-cell width in the dropdown.
        li.classList.remove('template-search__item');
        li.classList.add('predictive-search__list-item');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.setAttribute('data-sf-injected', 'predictive');
        dropdown.appendChild(li);

        const wrapper = li.querySelector('.card-wrapper') || li;
        if (wrapper) injectedWrappers.push(wrapper);

        // Click-correctness mitigation: rewrite the product link to include the matching variant id.
        const jsonEl = wrapper.querySelector('#variant-json');
        if (jsonEl) {
          try {
            const data = JSON.parse(jsonEl.textContent);
            const matching = (data.variants || []).find((v) => skuMatches(v.sku));
            if (matching && matching.id) {
              li.querySelectorAll('a[href*="/products/"]').forEach((a) => {
                const href = a.getAttribute('href') || '';
                if (href.includes('?variant=') || href.includes('&variant=')) return;
                const sep = href.includes('?') ? '&' : '?';
                a.setAttribute('href', `${href}${sep}variant=${matching.id}`);
              });
            }
          } catch (e) { PERR('variant-json parse failed:', e); }
        }

        // Hover SKU observer (same pattern as Phase 5)
        li.querySelectorAll('.card-wrapper').forEach((w) => {
          const apply = () => {
            const vid = w.getAttribute('swatch-current-variant');
            if (!vid) return;
            const je = w.querySelector('#variant-json');
            const se = w.querySelector('.card-hover-sku');
            if (!je || !se) return;
            try {
              const d = JSON.parse(je.textContent);
              const m = (d.variants || []).find((v) => String(v.id) === String(vid));
              if (m && m.sku) se.textContent = m.sku;
            } catch (e) {}
          };
          const obs = new MutationObserver(apply);
          obs.observe(w, { attributes: true, attributeFilter: ['swatch-current-variant'], subtree: false });
          apply();
        });
      });

      // Scoped swatch processing: run over native dropdown cards + injected cards.
      // No globals touched; main-page cards untouched.
      const allDropdownWrappers = nativeCards.concat(injectedWrappers);
      PLOG(`"${t}" | triggering scoped swatch processing on ${allDropdownWrappers.length} dropdown card(s)`);
      processCardsWithTerm(allDropdownWrappers, t);
    };

    // Serve from cache if we've already processed this exact term.
    if (predictiveCache[key]) {
      PLOG(`"${t}" | cache hit`);
      runPipeline(predictiveCache[key].extras, predictiveCache[key].renderedHtml);
      return;
    }

    const gql = `query($q: String!) {
      products(first: 6, query: $q) {
        edges { node { handle title variants(first: 50) { edges { node { sku title } } } } }
      }
    }`;

    const t0 = performance.now();
    fetch(`https://${cfg.shop}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token },
      body: JSON.stringify({ query: gql, variables: { q: t } }),
      signal: signal
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.errors) { PERR('GraphQL errors:', data.errors); return null; }
        const products = (data.data && data.data.products && data.data.products.edges || []).map((e) => e.node);
        const existingSet = existingHandles();
        const extras = products.filter((p) => !existingSet.has(p.handle));
        PLOG(`"${t}" | storefront ${products.length} total, ${extras.length} extras after dedupe (${existingSet.size} already in dropdown) | ${Math.round(performance.now() - t0)}ms`);
        if (extras.length === 0) return { extras: [], renderedHtml: '' };

        const handlesParam = extras.map((p) => p.handle).join(',');
        return fetch(`/search?q=${encodeURIComponent(handlesParam)}&sections=storefront-card-renderer`, { signal: signal })
          .then((r) => r.json())
          .then((json) => ({ extras: extras, renderedHtml: json['storefront-card-renderer'] || '' }));
      })
      .then((result) => {
        if (!result) return;
        if (inFlightTerm !== key) {
          PLOG(`"${t}" | term changed before completion, discarding`);
          return;
        }
        predictiveCache[key] = result;
        runPipeline(result.extras, result.renderedHtml);
      })
      .catch((e) => {
        if (e && e.name === 'AbortError') return;
        PERR('predictive pipeline failed:', e);
      });
  };
})();

